import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "but_table_confirmbet",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "110",
  height: "40",
  viewBox: "0 0 110 40"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><linearGradient id=\"cancel-linear-gradient\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" stop-color=\"#ffa2a2\"></stop><stop offset=\"1\" stop-color=\"#ff3d3d\"></stop></linearGradient><linearGradient id=\"cancel-linear-gradient-2\" x1=\"0.5\" x2=\"0.5\" y2=\"1\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" stop-color=\"#ffd5d5\"></stop><stop offset=\"1\" stop-color=\"#b93e3e\"></stop></linearGradient></defs><g id=\"but_more\"><rect id=\"Rectangle_45\" data-name=\"Rectangle 45\" width=\"110\" height=\"40\" rx=\"5\" fill=\"url(#cancel-linear-gradient)\"></rect><path id=\"矩形_46\" data-name=\"矩形 46\" d=\"M5,1A4,4,0,0,0,1,5V35a4,4,0,0,0,4,4H105a4,4,0,0,0,4-4V5a4,4,0,0,0-4-4H5M5,0H105a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z\" fill=\"url(#cancel-linear-gradient-2)\"></path></g>", 2)
const _hoisted_4 = {
  id: "取消投注",
  transform: "translate(33 26)",
  fill: "#fff",
  "font-size": "16",
  "font-family": "PingFangSC-Regular, PingFang SC"
}
const _hoisted_5 = {
  x: "0",
  y: "0"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<g id=\"icon_table_cancel\" transform=\"translate(11 11)\"><g id=\"Ellipse_23\" data-name=\"Ellipse 23\" fill=\"none\" stroke=\"#fff\" stroke-width=\"1\"><circle cx=\"9\" cy=\"9\" r=\"9\" stroke=\"none\"></circle><circle cx=\"9\" cy=\"9\" r=\"8.5\" fill=\"none\"></circle></g><path id=\"Path_5\" data-name=\"Path 5\" d=\"M-350.308,25.734l7.272,7.272\" transform=\"translate(355.672 -20.37)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></path><path id=\"Path_6\" data-name=\"Path 6\" d=\"M-343.036,25.734l-7.272,7.272\" transform=\"translate(355.672 -20.37)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"2\"></path></g>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("text", _hoisted_4, [
      _createElementVNode("tspan", _hoisted_5, _toDisplayString(_ctx.text), 1)
    ]),
    _hoisted_6
  ]))
}